import React from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { createSupplierFeedback, getAllSupplierFeedbackById } from "../../../../action";
import SupplierComment from "../SupplierComment";
import { TabTitle } from "../../../../util/titleChanger";
import { useState } from "react";
import { GlobalState } from "../../../../GlobalState";

export default function SupplierFeedbackForm() {
  TabTitle("Supplier Comment");
  const { supId } = useParams();

  const state = useContext(GlobalState);
  const signInUser = JSON.parse(localStorage.getItem("user_data"));

  //Local State
  const [values, setValues] = useState({});
  const [focused, setFocused] = useState(false);

  //Import customer comment from global state
  const [supplierFeedbackData, setSupplierFeedbackData] = useState([]);
  const [supplierFeedbacks] = state.supplierFeedbackAPI.supplierFeedbacks;
  const [callback, setCallback] = state.supplierFeedbackAPI.callback;

  //For auto complete state
  const [allSuppliers] = state.supplierAPI.allSuppliers;
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectSupplier, setSelectSupplier] = useState("");
  const suggestions = allSuppliers.filter((supplier) => supplier.first_name.toString().toLowerCase().includes(selectSupplier.toString().toLowerCase()));

  const handleSuggestionClick = (suggestion) => {
    setSelectSupplier(suggestion.first_name + " " + suggestion.last_name);
    setShowSuggestions(false);
    setValues({
      ...values,
      supplierId: suggestion.id,
    });
  };

  const onChangeSelectSupplier = (e) => {
    setSelectSupplier(e.target.value);
  };

  const onChangeValue = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleFocus = (e) => {
    setFocused(false);
  };

  useEffect(() => {
    supplierFeedbacks ? setSupplierFeedbackData(supplierFeedbacks) : setSupplierFeedbackData([]);

    if (supId > 0) {
      getAllSupplierFeedbackById(supId, (res) => {
        setSupplierFeedbackData(res);
      });
    }
  }, [allSuppliers, supplierFeedbacks, supId]);

  const submitDefault = (e) => {
    e.preventDefault();

    const feedbackInfo = {
      note: values.note,
      supplierId: values.supplierId,
      updatedBy: signInUser.id,
      createdBy: signInUser.id,
    };

    createSupplierFeedback(feedbackInfo, (res) => {
      if (res.status === 200) {
        setCallback(!callback);
        setSupplierFeedbackData(supplierFeedbacks);
      }
    });
  };

  console.log(supplierFeedbackData);

  return (
    <div className="form-container">
      <form onSubmit={submitDefault} className="form">
        <div className="input-box">
          <label htmlFor="supplierId">Supplier Name</label>
          <input
            type="text"
            name="supplierId"
            id="supplierId"
            placeholder="Enter Supplier Name"
            value={selectSupplier}
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeSelectSupplier}
            onFocus={() => setShowSuggestions(true)}
          />
          {showSuggestions && (
            <ul className="suggestions">
              {suggestions.map((suggestion) => (
                <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion)}>
                  {suggestion.first_name + "" + suggestion.last_name}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="input-box">
          <textarea name="note" id="note" cols="30" rows="5" placeholder="Enter feedback here..." value={values.note || ""} onChange={onChangeValue} />
        </div>
        <div className="form-button">
          <button className="add_new">Submit</button>
        </div>
      </form>
      {supplierFeedbackData.status === 200 ? (
        supplierFeedbackData.data.data.map((feedback) => (
          <div key={feedback.id}>
            <SupplierComment feedback={feedback} />
          </div>
        ))
      ) : (
        <div></div>
      )}
    </div>
  );
}
